import { type Address } from 'viem'

import { ErrorLayout } from '@/ui/layouts/ErrorLayout'
import { Typography } from '@/ui/atoms/typography/Typography'
import { BlockExplorerAddressLink } from '@/ui/molecules/block-explorer-address-link/BlockExplorerAddressLink'
import { CheckedAddress } from '@/domain/types/CheckedAddress'

export function RestrictedAddressPage({ address }: { address: Address }) {
  return (
    <ErrorLayout fullScreen={true} className="px-6 text-center">
      <>
        <Typography className="text-base md:pt-8">
          Your wallet address has been found to be owned by or affiliated with an individual or entity on{' '}
          <a
            href="https://home.treasury.gov/policy-issues/financial-sanctions/specially-designated-nationals-and-blocked-persons-list-sdn-human-readable-lists"
            target="_blank"
            rel="noopener"
            className="text-primary underline"
          >
            OFAC&apos;s SDN List
          </a>
          .
        </Typography>

        <div className="grid grid-cols-2 gap-2 border-basics-border border-t py-4">
          <Typography>Address</Typography>
          <BlockExplorerAddressLink
            address={CheckedAddress(address)}
            className="text-muted-foreground text-sm leading-none tracking-tight "
          />
        </div>

        <Typography className="text-base md:pt-8">
          Use of this site is restricted pursuant to our{' '}
          <a
            href="https://home.treasury.gov/policy-issues/financial-sanctions/specially-designated-nationals-and-blocked-persons-list-sdn-human-readable-lists"
            target="_blank"
            rel="noopener"
            className="text-primary underline"
          >
            Terms of Use
          </a>
        </Typography>
      </>
    </ErrorLayout>
  )
}
